export const findPatternCells = (pattern)=>{

    const patternCells = {};
    const {row,col,word,direction} = pattern;

    if(direction === 0){ //horizontal
        for(let i=0;i<word.length;i++){
            const key = `${row}_${col+i}`;
            patternCells[key]=key;                
        }
    }else if(direction === 1){ //vertical
        for(let i=0;i<word.length;i++){
            const key = `${row+i}_${col}`;
            patternCells[key]=key;
        }
    }

    return patternCells;

};

export const getpatternCellsCoords = (pattern)=>{
    const patternCells = findPatternCells(pattern);

    return Object.keys(patternCells).map(c=>{
        const [row,col] = c.split('_').map(coord=> +coord);

        return {row,col};
    });
    
};

export const patternContainsCell = (pattern,row,col)=>{
    const patternCells = findPatternCells(pattern);
    return !!patternCells[`${row}_${col}`];
};

export const setCaretPosition =  (oField, iCaretPos)=> {

    // IE Support
    if (document.selection) { 

      // Set focus on the element
      oField.focus ();
 
      // Create empty selection range
      var oSel = document.selection.createRange ();
 
      // Move selection start and end to 0 position
      oSel.moveStart ('character', -oField.value.length);
 
      // Move selection start and end to desired position
      oSel.moveStart ('character', iCaretPos);
      oSel.moveEnd ('character', 0);
      oSel.select ();
    }

    // Firefox support
    else if (oField.selectionStart || oField.selectionStart === 0) {
      oField.selectionStart = iCaretPos;
      oField.selectionEnd = iCaretPos;
      oField.focus ();
    }
  };


  export const getCaretPosition = (oField)=> {

    // Initialize
    var iCaretPos = 0;

    // IE Support
    if (document.selection) { 

      // Set focus on the element
      oField.focus ();
 
      // To get cursor position, get empty selection range
      var oSel = document.selection.createRange ();
 
      // Move selection start to 0 position
      oSel.moveStart ('character', -oField.value.length);
 
      // The caret position is selection length
      iCaretPos = oSel.text.length;
    }

    // Firefox support
    else if (oField.selectionStart || oField.selectionStart === 0)
      iCaretPos = oField.selectionStart;

    // Return results
    return (iCaretPos);
  }
